import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

import { Store } from '@ngrx/store';

import * as sharedComponents from '../../../shared/components';
import { BrowserCheckService } from '../../services';
import { ChunkErrorHandler } from '../../../shared/util';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AppComponent extends sharedComponents.WireframeComponent implements OnInit {
  constructor(
    store$: Store<any>,
    router: Router,
    activatedRoute: ActivatedRoute,
    titleService: Title,
    private browserCheck: BrowserCheckService,
  ) {
    super(store$, router, activatedRoute, titleService);
    ChunkErrorHandler.init(router);
    ChunkErrorHandler.restoreRoute();
  }

  ngOnInit() {
    super.ngOnInit();
    if (localStorage.getItem('isBrowserWarningClosed') !== 'true') {
      this.browserCheck.checkBrowser();
    }
  }
}
